import { render } from "./Registerlayout.vue?vue&type=template&id=ea062e2a"
import script from "./Registerlayout.vue?vue&type=script&lang=js"
export * from "./Registerlayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\travel\\travel\\admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__